import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

enum TRAINING_TYPE {
  HEALTH_AND_REHABILITATION = 'HEALTH_AND_REHABILITATION',
  MEDICO_TECHNICAL = 'MEDICO_TECHNICAL',
}

enum TRAINING_LEVEL {
  LEVEL_3 = 'LEVEL_3',
  LEVEL_4 = 'LEVEL_4',
  LEVEL_5 = 'LEVEL_5',
  LEVEL_6 = 'LEVEL_6',
  LEVEL_7 = 'LEVEL_7',
  LEVEL_8 = 'LEVEL_8',
}

enum TRAINING_IMG {
  AIDE_SOIGNANT = 'AIDE_SOIGNANT',
  FIOLE = 'FIOLE',
  PLANCHE_BALANCE = 'PLANCHE_BALANCE',
  RADIO = 'RADIO',
  SERINGUE = 'SERINGUE',
  VIRUS = 'VIRUS',
  SECRETARY = 'SECRETARY',
}

@Injectable({
  providedIn: 'root',
})
export class TrainingService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public getAllTraining(): Observable<any> {
    const body = {
      query: `
        query {
          fetchAllTraining {
            id
            organization {
              address
              city
              company_name
              email
              id
              phone_number
              pronote_link
              postal_code
              website_url
            }
            file
            img
            job_title
            level
            start_of_apprenticeship
            school_start_date
            application_period
            selection_period
            success_rate
            success_rate_year
            type
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public trainingList(): Observable<any> {
    const body = {
      query: `
        query {
          listTrainings(filter: {visibility: {eq: true}}) {
            items {
              job_title
              id
              file
              img
              createdAt
            }
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public getTraining(id: string): Observable<any> {
    const body = {
      query: `
        query GetTraining($id: ID!) {
          getTraining(id: $id) {
            file
            id
            img
            job_title
            level
            start_of_apprenticeship
            school_start_date
            application_period
            selection_period
            success_rate
            success_rate_year
            visibility
            type {
              id
              name
            }
            organization {
              address
              city
              company_name
              email
              id
              phone_number
              postal_code
              pronote_link
            }
          }
        }
      `,
      variables: { id },
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public deleteTraining(id: string): Observable<any> {
    const body = {
      query: `
        mutation {
          deleteTraining(input: {id: "${id}"}) {
            id
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public polesList(): Observable<any> {
    const body = {
      query: `
        query {
            listPoles{
              items {
                content
                createdAt
                id
                name
              }
            }
          }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public listTrainingsByPole(): Observable<any> {
    const body = {
      query: `
        query {
            listPoles{
              items {
                content
                createdAt
                id
                name
                training(filter: {visibility: {eq: true}}) {
                  items {
                    createdAt
                    file
                    id
                    img
                    job_title
                    level
                    organization {
                      company_name
                    }
                    organizationTrainingId
                    poleTrainingId
                    start_of_apprenticeship
                    school_start_date
                    application_period
                    selection_period
                    success_rate
                    success_rate_year
                    visibility
                  }
                }
              }
            }
          }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
  public fetchTrainingByOrganizationHealth(): Observable<any> {
    const body = {
      query: `
        query {
          fetchTrainingByOrganizationHealth {
            id
            training {
              id
              job_title
              file
              img
              level
              start_of_apprenticeship
              school_start_date
              application_period
              selection_period
              success_rate
              success_rate_year
              type
              visibility
            }
            address
            city
            company_name
            email
            phone_number
            postal_code
            social_reason
            pronote_link
            website_url
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
